import React from 'react';
import StatusPill, { type StatusColorVariant } from '../common/StatusPill';

export type PoolStatusType = 'pending' | 'ready' | 'resizing' | 'error' | 'decommissioning' | 'decommissioned';

interface PoolStatusProps {
  status: string;
  className?: string;
}

const PoolStatus: React.FC<PoolStatusProps> = ({ status, className = '' }) => {
  const normalizedStatus = status.toLowerCase() as PoolStatusType;

  const getStatusColorVariant = (status: PoolStatusType): StatusColorVariant => {
    switch (status) {
      case 'ready':
        return 'success';
      case 'error':
        return 'error';
      case 'decommissioned':
        return 'dark';
      case 'decommissioning':
        return 'neutral';
      case 'pending':
      case 'resizing':
        return 'warning';
      default:
        return 'neutral';
    }
  };

  const getStatusText = (status: string): string => {
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  return (
    <StatusPill
      status={normalizedStatus}
      colorVariant={getStatusColorVariant(normalizedStatus)}
      textTransform={getStatusText}
      className={className}
    />
  );
};

export default PoolStatus;
